import React from 'react';
import { motion } from 'framer-motion';

const PageHero = ({ badge, title, titleAccent, description, image, BadgeIcon }) => {
  return (
    <section className="relative pt-36 md:pt-44 min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-[#002240]/95 via-[#003057]/85 to-[#003057]/55 z-10" />
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
          fetchPriority="high"
        />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          {badge && (
            <div className="inline-flex items-center gap-2 bg-[#C9A227] text-[#002240] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              {BadgeIcon && <BadgeIcon size={16} />}
              {badge}
            </div>
          )}
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white leading-tight">
            {title} {titleAccent && <span className="text-[#00A3E0]">{titleAccent}</span>}
          </h1>
          <p className="text-xl text-gray-200 leading-relaxed">
            {description}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
